// Action types for fetching recent deals
export const FETCH_RECENT_DEALS_REQUEST = 'FETCH_RECENT_DEALS_REQUEST';
export const FETCH_RECENT_DEALS_SUCCESS = 'FETCH_RECENT_DEALS_SUCCESS';
export const FETCH_RECENT_DEALS_FAILURE = 'FETCH_RECENT_DEALS_FAILURE';

// Open Recent Deals
export const SHOW_RECENT_DEALS = 'SHOW_RECENT_DEALS';
export const HIDE_RECENT_DEALS = 'HIDE_RECENT_DEALS';

// Operations on individual deals
export const SELECT_DEAL = 'SELECT_DEAL';

// Host Actions operations
export const OPEN_RECENT_DEAL = 'OPEN_RECENT_DEAL';
export const REDIRECT_TO_DEAL_LIST = 'REDIRECT_TO_DEAL_LIST';
export const CREATE_QUOTE = 'CREATE_QUOTE';
